import { render, staticRenderFns } from "./Shadow.vue?vue&type=template&id=6e316c70"
import script from "./Shadow.vue?vue&type=script&lang=js"
export * from "./Shadow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports